<div id="dsw" style="min-height: auto; padding-bottom: 0">
  <div class="popup-overlay"></div>
  <div class="cst-popup popup-selecteddealermap width650">
    <div class="popup-header">
      <div class="flex-center space-between">
        <h2>{{ this.preferedDealer.dealerName }} - Distance in km {{ this.distanceInKm | number: '1.2-2' }}</h2>
        <em (click)="activeModal.close()" data-popup="-mobilenumber"
          class="fas fa-times close-icn-popup popup-close"></em>
      </div>
    </div>
    <div class="popup-content">
      <div>
        <google-map [center]="{ lat: latitude, lng: longitude }" style="height: 400px;">
          <map-polyline [path]="[{ lat: origin.lat, lng: origin.lng }, { lat: destination.lat, lng: destination.lng }]" 
                        [options]="renderOptions"></map-polyline>
          <map-marker [position]="{ lat: origin.lat, lng: origin.lng }" [options]="markerOptions.origin"></map-marker>
          <map-marker [position]="{ lat: destination.lat, lng: destination.lng }" [options]="markerOptions.destination"></map-marker>
        </google-map>
      </div>
    </div>
  </div>
</div>
